// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__Ys8sl","red":"Button_red__1F8wb","white":"Button_white__2HrKB"};